import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { PageHero, CTABand } from "@/components/blocks";
import { SERVICES, IMAGES } from "@/data/content";

export default function Services() {
  return (
    <div data-testid="services-page">
      <Seo title="Nos services | E85, banc de puissance, diagnostic — Horsepower Garage"
        description="Découvrez les services Horsepower : conversion E85 FlexFuel, banc de puissance, diagnostic électronique et préparation automobile."
        canonical="https://www.horsepowergarage.fr/services" />
      <PageHero eyebrow="Nos services" title="Une expertise complète au service de la performance"
        subtitle="Reprogrammation, conversion E85, banc de puissance, diagnostic et préparation : tout l'écosystème Horsepower."
        image={IMAGES.engineSteel} />

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-20">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 0.08}>
              <Link to={s.path} className="hp-card group flex flex-col overflow-hidden h-full" data-testid={`service-card-${s.slug}`}>
                <div className="overflow-hidden bg-black aspect-[4/5]">
                  <img src={s.image} alt={s.name} className={`h-full w-full ${s.fit === "cover" ? "object-cover" : "object-contain"} transition-transform duration-500 group-hover:scale-[1.03]`} loading="lazy" />
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-display font-bold uppercase tracking-tight text-2xl group-hover:text-hp-yellow transition-colors">{s.name}</h3>
                  <p className="text-neutral-400 leading-relaxed mt-2">{s.desc}</p>
                  <span className="inline-flex items-center gap-1 text-hp-yellow text-xs font-bold uppercase tracking-wide mt-auto pt-4">En savoir plus <ArrowRight size={14} /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </div>
  );
}
